// frontend/src/services/weeklyReportService.js
import api from './api';

const weeklyReportService = {
  // Obtener la configuración actual de la cuenta
  getConfig: async () => {
    const res = await api.get('/weekly-report/');
    // El viewset retorna una lista; tomamos el primero (o null)
    return res.data.results ?? res.data;
  },

  createConfig: async (data) => {
    const res = await api.post('/weekly-report/', data);
    return res.data;
  },

  updateConfig: async (id, data) => {
    const res = await api.patch(`/weekly-report/${id}/`, data);
    return res.data;
  },

  // Retorna el HTML del informe para la vista previa (autenticado via axios)
  getPreviewHtml: async (id) => {
    const res = await api.get(`/weekly-report/${id}/preview/`);
    return res.data;
  },

  // Envío manual
  sendNow: async (id) => {
    const res = await api.post(`/weekly-report/${id}/send-now/`);
    return res.data;
  },

  deleteConfig: async (id) => {
    await api.delete(`/weekly-report/${id}/`);
  },

  getPlatforms: async () => {
    const res = await api.get('/platforms/');
    return res.data.results ?? res.data;
  },

  getDesarrolla: async () => {
    const res = await api.get('/desarrolla/');
    return res.data.results ?? res.data;
  },

  // Lista de usuarios disponibles para la cuenta
  getUsers: async () => {
    const res = await api.get('/users/');
    return res.data;
  },
};

export default weeklyReportService;
